import { InvestorSearchAside } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchAside';
import { InvestorSearchLayout } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchLayout';
import React from 'react';
export const InvestorSearchPage = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <InvestorSearchLayout asidePanel={<InvestorSearchAside />} mainPanel={page} />;
  };
  return Component;
};